export default __webpack_public_path__ + "static/media/Punto_07_Il_Pontino_ENG_Def.05997f85.aac";